import Status from '@/common/TradeCard/Status';
import useGetTradeInStatus from '~/hooks/common/useGetTradeStatus';

type OwnProps = {
  abbreviateTitle?: boolean;
};

export default function TradeHeading({ abbreviateTitle }: OwnProps) {
  const tradeStatus = useGetTradeInStatus();

  const titleText = `${abbreviateTitle ? '' : 'Sell/'}Trade Offer`;

  return (
    <div className="flex flex-wrap justify-between gap-4">
      <h3 className="text-blue-6 tl-header-m" data-qa="trade-card-heading">
        {titleText}
      </h3>
      <Status tradeStatus={tradeStatus} />
    </div>
  );
}
